import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const CompactCard = ({ title, icon: Icon, children, maxHeight = 320, noScroll = false, dense = false, sx = {} }) => (
  <Paper
    elevation={0}
    sx={{
      display: "flex",
      flexDirection: "column",
      height: "100%",
      maxHeight,
      overflow: "hidden",
      borderRadius: 2.5,
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
      transition: "box-shadow 0.2s ease",
      "&:hover": { boxShadow: "0 8px 20px rgba(0,0,0,0.08)" },
      ...sx,
    }}
  >
    <Box sx={{ px: 1.5, py: dense ? 0.5 : 1, display: "flex", alignItems: "center", gap: dense ? 0.75 : 1, flexShrink: 0, borderBottom: "1px solid", borderColor: "divider" }}>
      {Icon && (
        <Box sx={{ width: dense ? 20 : 26, height: dense ? 20 : 26, borderRadius: 1.5, display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "primary.main", color: "primary.contrastText", flexShrink: 0 }}>
          <Icon sx={{ fontSize: dense ? "0.75rem" : "0.95rem" }} />
        </Box>
      )}
      <Typography variant="subtitle2" fontWeight={700} sx={{ fontSize: dense ? "0.7rem" : "0.8rem", letterSpacing: 0.2 }}>
        {title}
      </Typography>
    </Box>
    <Box
      sx={{
        flex: 1,
        overflowY: noScroll ? "hidden" : "auto",
        overflowX: "auto",
        "&::-webkit-scrollbar": { width: 5 },
        "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(0,0,0,0.18)", borderRadius: 3 },
        "& .MuiTypography-root": { fontSize: "0.78rem" },
        "& .MuiButton-root": { fontSize: "0.68rem", padding: "2px 8px", minWidth: "auto" },
        "& .MuiChip-root": { height: 18, fontSize: "0.6rem" },
        "& .MuiChip-label": { padding: "0 6px" },
        "& .MuiIconButton-root": { padding: "4px" },
        "& .MuiSvgIcon-root": { fontSize: "1rem" },
        "& .MuiTableCell-root": { padding: "4px 8px", fontSize: "0.72rem" },
        "& .MuiAvatar-root": { width: 24, height: 24 },
      }}
    >
      {children}
    </Box>
  </Paper>
);

export default CompactCard;